import * as React from 'react';
import { UndergroundMapV2 as UndergroundMap } from '../../components/UndergroundMapV2';
import { prepareStationsV2 } from '../../mappers/prepareStationsV2';
import { useUndergroundActions } from '../../hooks/useUndergroundActions';
export var UndergroundMapV2 = function UndergroundMapV2(_ref) {
  var apiRef = _ref.apiRef,
      data = _ref.data,
      selectedStations = _ref.selectedStations,
      onSelect = _ref.onSelect,
      onRemove = _ref.onRemove;
  var stations = React.useMemo(function () {
    return prepareStationsV2(data);
  }, [data]);

  var _useUndergroundAction = useUndergroundActions({
    onSelect: onSelect,
    onRemove: onRemove,
    apiRef: apiRef,
    stations: stations,
    groups: data.meta.stationGroups
  }),
      handleRemove = _useUndergroundAction.handleRemove,
      handleSelect = _useUndergroundAction.handleSelect;

  return /*#__PURE__*/React.createElement(UndergroundMap, {
    data: data,
    onSelect: handleSelect,
    onRemove: handleRemove,
    selectedStations: selectedStations
  });
};